module.exports = __webpack_public_path__ + "img/pagamento.46666d31.svg";